import React, { PureComponent } from "react";

import Select from "react-select";

import numeral from "numeral";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";

import { LineInput } from "components/Inputs/LineInput";
import Tooltip from "components/Inputs/Tooltip";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { getBaselineMatrixFromSetup } from "containers/Project/reducer";

import { Popover, OverlayTrigger } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faChevronLeft,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faEdit,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faCompressArrowsAlt,
  faExpandArrowsAlt,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import CrownIcon from "images/CrownIcon.svg";
import LightningBoltIcon from "images/lightningbolt.svg";
import WarningIcon from "images/warning.svg";

import { UNIFIED_PROJECT_STEPS } from "containers/Business/BusinessReducer";

import ModelError from "components/Results/ModelError";
import FunnelTooltip from "components/Business/ModelBox/FunnelTooltip";
import ModelLabels from "components/Business/ModelBox/ModelLabels";
import TinyBarChart from "components/Project/TinyBarChart";
import BusinessConstraints from "containers/Business/Strategy/BusinessConstraints";
import PieChart from "components/Project/PieChart";

import styles from "./style.module.css";

export default class ModelBox extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      mode: "OVERVIEW",
      isDeployingProject: false,
      newScenarioName: "New Scenario",
      viewportWidth: 0,
      viewportHeight: 0,
      binsMax: 0
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight
    });
  }

  parseValueName(name) {
    if (name.includes("more than ") && name.includes(" to ")) {
      return name.replace("more than", ">");
    }
    return name;
  }

  getMaxRevenue(models) {
    const { data, setup } = this.props;

    return Math.max.apply(
      Math,
      models.map((m) => m.maxIteration.truePositive * setup.conversionGain)
    );
  }

  getMinRevenue(models) {
    const { data, setup } = this.props;

    return Math.min.apply(
      Math,
      models.map((m) => m.maxIteration.truePositive * setup.conversionGain)
    );
  }

  getMaxCost(models) {
    const { data, setup } = this.props;

    return Math.max.apply(
      Math,
      models.map((m) => Math.abs((m.maxIteration.truePositive + m.maxIteration.falsePositive) * setup.conversionCost))
    );
  }

  getMinCost(models) {
    const { data, setup } = this.props;

    return Math.min.apply(
      Math,
      models.map((m) => Math.abs((m.maxIteration.truePositive + m.maxIteration.falsePositive) * setup.conversionCost))
    );
  }

  getNewValue(oldValue, oldMax) {
    const { isSmall, strategy } = this.props;

    const { overallOnly, isOverallSegment } = this.props;
    const retWidth = isSmall || strategy ? 300 : 130;
    return Math.max(((oldValue - 0) * (retWidth - 0)) / (oldMax - 0), 0);
  }

  getNewValueCapped(oldValue, oldMax, cap) {
    return ((oldValue - 0) * (cap - 0)) / (oldMax - 0) + 0;
  }

  getNewValueBar(oldValue, oldMin, oldMax) {
    return ((oldValue - oldMin) * (100 - 0)) / (oldMax - oldMin) + 0;
  }

  renderBadges(type) {
    const { allBusinessConstraints } = this.props;

    if (!allBusinessConstraints) {
      return;
    }

    return (
      <div className={styles.sBadgeHolder}>
        {allBusinessConstraints
          .filter((c) => c.primary && c.primary.type === type)
          .map((c, i) => {
            if (c.subgroup === "Overall") {
              return (
                <div className={styles.subBadge} style={{ background: c.color }} key={`badge-${type}-i`}>
                  {"Strategy"}
                </div>
              );
            } else {
              return <div className={styles.subBullet} style={{ background: c.color }} key={`badge-${type}-i`} />;
            }
          })}
      </div>
    );
  }

  renderOverviewContinuous() {
    const {
      id,
      isSmall,
      isOverallSegment,
      optimized,
      segmentConfusionMatrices,
      rSetup,
      modelGroups,
      transactionLabel,
      outcomeLabel,
      notPursuedTransactionLabel,
      trueAction,
      falseAction,
      unitType,
      revenueLabel,
      profitLabel,
      truePositiveLabel,
      setupLabels,
      runId,
      showSubgroup,
      updateShowBusiness,
      updateShowImpact,
      overallOnly,
      isMini,
      updateDrilldownValue,
      title,
      selectStep,
      businessAssumptions,
      isTraining
    } = this.props;
    const { mode } = this.state;

    const activeSlice =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.runId === runId)[0]
        : undefined;

    const overallSlice = modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues[0];

    const setup = optimized && optimized.setup ? optimized.setup : rSetup;

    const cSetup = activeSlice ? activeSlice.setup : {};

    const bMetrics =
      activeSlice && activeSlice.bestModel && activeSlice.bestModel.metrics
        ? activeSlice.bestModel.metrics
        : optimized
          ? {
              underImpact: optimized.underEstimate,
              overImpact: optimized.overEstimate
            }
          : undefined;

    const isOverall = (activeSlice && activeSlice.value === "Overall") || showSubgroup;

    const cBaselineContinuousValue = Number(
      isOverall && optimized ? optimized.overallContinuousValue : cSetup.baselineValueContinuous
    );

    const cBaselineContinuousCount = Number(
      isOverall && optimized ? optimized.overallContinuousCount : cSetup.baselineCountContinuous
    );

    const cOverallContinuousPercent = Number(
      isOverall && optimized ? optimized.overallContinuousPercent : cSetup.continuousPercent
    );

    const cPotentialProfit = cBaselineContinuousValue * cBaselineContinuousCount * cOverallContinuousPercent;

    const cTotalProfit = isOverall && optimized ? optimized.overallCurrentProfit : cSetup.currentProfit;

    const cUnderLoss = (cPotentialProfit - cTotalProfit) / 2;
    const cOverLoss = (cPotentialProfit - cTotalProfit) / 2;

    const nExpectedContinuousValue = Number(
      isOverall && optimized ? optimized.overallExpectedContinuousValue : cSetup.expectedValueContinuous
    );
    const nExpectedContinuousCount = Number(
      isOverall && optimized ? optimized.overallExpectedContinuousCount : cSetup.expectedCountContinuous
    );
    const nOverallContinuousPercent = Number(
      isOverall && optimized ? optimized.overallContinuousPercent : cSetup.continuousPercent
    );

    const nPotentialProfit = nExpectedContinuousValue * nExpectedContinuousCount * nOverallContinuousPercent;
    const nUnderLoss = bMetrics ? bMetrics.underImpact : 0;
    const nOverLoss = bMetrics ? bMetrics.overImpact : 0;
    const nTotalProfit = bMetrics ? nPotentialProfit - (bMetrics.underImpact + bMetrics.overImpact) : 0;

    const oldMax = Math.max(cPotentialProfit, nPotentialProfit);

    const cLeads = this.getNewValue(cPotentialProfit, oldMax);
    const cOpps = this.getNewValue(cPotentialProfit - cOverLoss, oldMax);
    const cWins = this.getNewValue(cTotalProfit, oldMax);

    const nLeads = this.getNewValue(nPotentialProfit, oldMax);
    const nOpps = this.getNewValue(nPotentialProfit - nOverLoss, oldMax);
    const nWins = this.getNewValue(nTotalProfit, oldMax);

    const activeColor =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId && d.column !== "Overall").length > 0
        ? modelGroups.drilldownValues.filter((d) => d.runId === runId)[0].color
        : "#7E69D7";

    const defaultGrey = showSubgroup ? activeSlice.color : "rgb(204, 204, 204)";

    const currentSegment =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId && d.column == "Overall").length > 0
        ? "Overall"
        : "Optimized";

    const costDelta = showSubgroup
      ? numeral(overallSlice.totalCost - activeSlice.totalCost).format("0.0a")
      : optimized && optimized.currentSpend && optimized.totalCost && optimized.totalCost - optimized.currentSpend;

    const profitDiffLabel = showSubgroup
      ? numeral(overallSlice.profit - activeSlice.profit).format("0.0a")
      : optimized &&
        optimized.profitDelta &&
        `${optimized.profitDelta > 0 ? "+" : "-"} ${
          setupLabels.unitType
        }${numeral(Math.abs(optimized.profitDelta)).format("0.0a")}`;

    const revenueDiffLabel = showSubgroup
      ? numeral(overallSlice.revenue - activeSlice.revenue).format("0.0a")
      : optimized &&
        optimized.revenueDelta &&
        `${optimized.revenueDelta > 0 ? "+" : "-"} ${
          setupLabels.unitType
        }${numeral(Math.abs(optimized.revenueDelta)).format("0.0a")}`;

    const allDriversAdded =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter(
        (group) => group && group.setup && group.column !== "Overall" && !group.setup.showImpact
      ).length;

    const numSegments = modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues.length;

    const subgroupCounts = {
      leads: [],
      opps: [],
      wins: []
    };
    if (modelGroups && modelGroups.drilldownValues) {
      const otherSegments = modelGroups.drilldownValues.filter((d) => d.value !== "Overall");
      const retSCM = segmentConfusionMatrices || {};
      otherSegments
        .filter((currSeg) => currSeg && currSeg.bestModel && currSeg.bestModel.metrics)
        .forEach((currSeg) => {
          const cMetrics = currSeg.bestModel.metrics;

          const tPotentialProfit =
            Number(currSeg.setup.expectedCountContinuous) * Number(currSeg.setup.expectedValueContinuous);

          const currLeads = {
            value: tPotentialProfit,
            color: isOverall ? currSeg.color : activeSlice.color
          };
          const currOpps = {
            value: tPotentialProfit - cMetrics.overImpact,
            color: isOverall ? currSeg.color : activeSlice.color
          };
          const currWins = {
            value: tPotentialProfit - cMetrics.overImpact - cMetrics.underImpact,
            color: isOverall ? currSeg.color : activeSlice.color
          };
          subgroupCounts.leads.push(currLeads);
          subgroupCounts.opps.push(currOpps);
          subgroupCounts.wins.push(currWins);
        });
    }

    const isPercentage = false;
    const isEmpty = false;

    const goToSegment = () => {
      if (runId) {
        updateDrilldownValue(runId, title);
      }
    };

    const goToStrategy = (step) => {
      if (step && !businessAssumptions) {
        selectStep(step);
      }
    };

    return (
      <div className={isSmall ? styles.smallContent : styles.mContent}>
        {isSmall === true ? (
          <div />
        ) : setup === undefined ? (
          <div className={styles.mColumn}>{"EMPTY"}</div>
        ) : (
          <div className={styles.mColumn}>
            <div className={styles.mSubTitle}>{showSubgroup ? activeSlice.value : "Baseline"}</div>
            <div className={styles.modelBarHolder} style={{ marginTop: "5px" }}>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {"Total Potential "}
                      <strong>{setupLabels.profitLabel}</strong>
                      {": "}
                    </span>
                    {unitType + numeral(cPotentialProfit).format("0.0a")}
                  </div>
                }
              >
                <div
                  className={styles.modelBar}
                  style={{
                    width: cLeads + "px",
                    background: defaultGrey,
                    opacity: 0.6
                  }}
                />
              </FunnelTooltip>
            </div>
            <FunnelTooltip
              tooltipText={
                <div>
                  <span style={{ fontWeight: "700" }}>
                    <strong>{setupLabels.overPredictAction}</strong>
                    {": "}
                  </span>
                  {unitType + numeral(cOverLoss).format("0.0a")}
                </div>
              }
            >
              <div className={styles.modelBarHolder}>
                <div
                  className={styles.modelBar}
                  style={{
                    width: cLeads + "px",
                    borderLeft: (cLeads - cOpps) / 2 + "px solid transparent",
                    borderRight: (cLeads - cOpps) / 2 + "px dotted transparent",
                    borderTop: "40px solid " + defaultGrey,
                    opacity: 0.2
                  }}
                />
              </div>
            </FunnelTooltip>
            <FunnelTooltip
              tooltipText={
                <div>
                  <span style={{ fontWeight: "700" }}>
                    <strong>{setupLabels.underPredictAction}</strong>
                    {": "}
                  </span>
                  {unitType + numeral(cUnderLoss).format("0.0a")}
                </div>
              }
            >
              <div className={styles.modelBarHolder}>
                <div
                  className={styles.modelBar}
                  style={{
                    width: cOpps + "px",
                    borderLeft: (cOpps - cWins) / 2 + "px solid transparent",
                    borderRight: (cOpps - cWins) / 2 + "px dotted transparent",
                    borderTop: "40px solid " + defaultGrey,
                    opacity: 0.3
                  }}
                />
              </div>
            </FunnelTooltip>
            <div className={styles.modelBarHolder}>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {"Total "}
                      <strong>{setupLabels.profitLabel}</strong>
                      {": "}
                    </span>
                    {unitType + numeral(cTotalProfit).format("0.0a")}
                  </div>
                }
              >
                <div
                  className={styles.modelBar}
                  style={{
                    width: cWins + "px",
                    background: defaultGrey
                  }}
                />
              </FunnelTooltip>
            </div>
            {/* <div className={styles.mInfo}>
              <span className={styles.mLargeGray}>
                {unitType +
                  (optimized
                    ? numeral(cUnderLoss + cOverLoss).format("0.0a")
                    : "")}
              </span>
            </div> */}
            <div className={styles.mInfo}>
              <span className={styles.mLargeGray}>{unitType + numeral(cOverLoss).format("0.0a")}</span>
            </div>
            <div className={styles.mInfo} style={{ marginTop: "20px" }}>
              <span className={styles.mLargeGray}>{unitType + numeral(cUnderLoss).format("0.0a")}</span>
            </div>
            <div className={styles.mInfo} style={{ marginTop: "20px" }}>
              <span className={styles.mLargeGray}>{unitType + numeral(cTotalProfit).format("0.0a")}</span>
            </div>
          </div>
        )}
        {isSmall !== true && (
          <div className={styles.mColumn}>
            <div className={styles.mSubTitle}>&nbsp;</div>
            <div className={styles.cMiddle} style={{ marginTop: "5px" }}>
              {"Potential " + setupLabels.profitLabel}
            </div>
            <div className={styles.cMiddle}>{"After " + setupLabels.overPredictAction}</div>
            <div className={styles.cMiddle}>{"After " + setupLabels.underPredictAction}</div>
            <div className={styles.cMiddle}>{"Expected " + setupLabels.profitLabel}</div>
            {/* <div className={styles.mMiddle} style={{ marginTop: "60px" }}>
              {"Cost"}
            </div> */}
            <div className={styles.cMiddle} style={{ marginTop: "40px" }}>
              {setupLabels.overPredictAction}
            </div>
            <div className={styles.cMiddle} style={{ marginTop: "20px" }}>
              {setupLabels.underPredictAction}
            </div>
            <div className={styles.cMiddle} style={{ marginTop: "20px" }}>
              {setupLabels.profitLabel}
            </div>
          </div>
        )}
        {!optimized ? (
          <div
            className={isSmall ? styles.mColumnFull : styles.mColumn}
            style={overallOnly ? { width: "calc(100% - 145px" } : {}}
          >
            <div className={styles.mSubTitle}>{currentSegment}</div>
          </div>
        ) : activeSlice === undefined || (isTraining && activeSlice?.numModels === 0) ? (
          <div style={{ fontWeight: "bold", marginLeft: "25px", marginTop: "5px" }}>
            {"Finding Optimal AI"}
            <LoadingIndicator style={{ marginLeft: "25px", marginTop: "20px" }} />
          </div>
        ) : (
          <div
            className={isSmall ? styles.mColumnFull : styles.mColumn}
            style={overallOnly ? { width: "calc(100% - 145px" } : {}}
          >
            <div className={styles.mSubTitle}>{currentSegment}</div>
            <div className={styles.modelBarHolder} style={{ marginTop: "5px" }}>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {"Total Potential "}
                      <strong>{setupLabels.profitLabel}</strong>
                      {": "}
                    </span>
                    {unitType + numeral(nPotentialProfit).format("0.0a")}
                  </div>
                }
              >
                <div
                  className={styles.modelBar + " " + styles.subgroupModels}
                  style={{
                    width: nLeads + "px",
                    background: activeColor,
                    opacity: 0.6
                  }}
                >
                  {subgroupCounts.leads.map((currSubgroup, i) => (
                    <div
                      key={"subgroup_leads" + i}
                      className={styles.subgroupModelBar}
                      style={{
                        width: currSubgroup.value + "%",
                        background: currSubgroup.color
                      }}
                    />
                  ))}
                </div>
              </FunnelTooltip>
            </div>
            <FunnelTooltip
              tooltipText={
                <div>
                  <span style={{ fontWeight: "700" }}>
                    <strong>{setupLabels.overPredictAction}</strong>
                    {": "}
                  </span>
                  {unitType + numeral(nOverLoss).format("0.0a")}
                </div>
              }
            >
              <div className={styles.modelBarHolder}>
                <div
                  className={styles.modelBar}
                  style={{
                    width: nLeads + "px",
                    borderLeft: (nLeads - nOpps) / 2 + "px solid transparent",
                    borderRight: (nLeads - nOpps) / 2 + "px dotted transparent",
                    borderTop: " 40px solid " + activeColor,
                    opacity: 0.2
                  }}
                />
              </div>
            </FunnelTooltip>
            <FunnelTooltip
              tooltipText={
                <div>
                  <span style={{ fontWeight: "700" }}>
                    <strong>{setupLabels.underPredictAction}</strong>
                    {": "}
                  </span>
                  {unitType + numeral(nUnderLoss).format("0.0a")}
                </div>
              }
            >
              <div className={styles.modelBarHolder}>
                <div
                  className={styles.modelBar}
                  style={{
                    width: nOpps + "px",
                    borderLeft: (nOpps - nWins) / 2 + "px solid transparent",
                    borderRight: (nOpps - nWins) / 2 + "px dotted transparent",
                    borderTop: " 40px solid " + activeColor,
                    opacity: 0.3
                  }}
                />
              </div>
            </FunnelTooltip>
            <div className={styles.modelBarHolder}>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {"Total "}
                      <strong>{setupLabels.profitLabel}</strong>
                      {": "}
                    </span>
                    {unitType + numeral(nTotalProfit).format("0.0a")}
                  </div>
                }
              >
                <div
                  className={styles.modelBar + " " + styles.subgroupModels}
                  style={{ width: nWins + "px", background: activeColor }}
                >
                  {subgroupCounts.wins.map((currSubgroup, i) => (
                    <div
                      key={"subgroup_wins" + i}
                      className={styles.subgroupModelBar}
                      style={{
                        width: currSubgroup.value + "%",
                        background: currSubgroup.color
                      }}
                    />
                  ))}
                </div>
              </FunnelTooltip>
            </div>
            {/* <div
            className={styles.mInfoRight}
            style={{ marginTop: isSmall ? "40px" : "50px" }}
          >
            <span className={styles.mLarge}>
              {unitType + (optimized ? numeral(runCost).format("0.0a") : "")}
            </span>
          </div> */}
            <div className={styles.mInfo}>
              <span className={styles.mLarge}>{unitType + numeral(nOverLoss).format("0.0a")}</span>
            </div>
            <div className={styles.mInfo} style={{ marginTop: "20px" }}>
              <span className={styles.mLarge}>{unitType + numeral(nUnderLoss).format("0.0a")}</span>
            </div>
            <div className={styles.mInfo} style={{ marginTop: "20px" }}>
              <span className={styles.mLarge}>{optimized ? unitType + numeral(nTotalProfit).format("0.0a") : ""}</span>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderOverview() {
    const {
      id,
      isTraining,
      isSmall,
      isContinuous,
      isOverallSegment,
      optimized,
      overallOptimized,
      segmentConfusionMatrices,
      rSetup,
      modelGroups,
      transactionLabel,
      outcomeLabel,
      notPursuedTransactionLabel,
      trueAction,
      falseAction,
      unitType,
      revenueLabel,
      profitLabel,
      project,
      truePositiveLabel,
      setupLabels,
      runId,
      nextId,
      showSubgroup,
      updateShowBusiness,
      updateShowImpact,
      showImpact,
      overallOnly,
      businessAssumptions,
      primaryBusinessConstraintType,
      currentStep,
      updateCurrentStep,
      strategy,
      showDelta,
      nextModelsHoverNode,
      isNext,
      ignoredModels,
      modelList
    } = this.props;
    const { mode } = this.state;

    if (isContinuous) {
      return this.renderOverviewContinuous();
    }

    const isOptimizerRunning = project && project.settings ? project.settings.optimizerIsRunning : false;

    const activeSlice =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.runId === runId)[0]
        : undefined;

    const overallSlice = modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues[0];

    const rMatrix = showSubgroup ? overallSlice.ccm : optimized ? optimized.constrainedConfusionMatrix : undefined;

    const setup = optimized && optimized.setup ? optimized.setup : rSetup;

    const rightSetup =
      showSubgroup && activeSlice && activeSlice.ccm
        ? {
            truePositive: activeSlice.ccm.tp,
            falsePositive: activeSlice.ccm.fp,
            trueNegative: activeSlice.ccm.tn,
            falseNegative: activeSlice.ccm.fn
          }
        : optimized && optimized.setup
          ? optimized.setup
          : rSetup;

    const comparisonOptions =
      setup?.comparisonOptions?.dateField && setup?.comparisonOptions?.currentStart
        ? setup.comparisonOptions
        : undefined;

    const currentMatrix = getBaselineMatrixFromSetup(rightSetup);

    const cTotal = rightSetup ? currentMatrix.tp + currentMatrix.fp + currentMatrix.fn + currentMatrix.tn : 0;
    const nTotal = rMatrix ? rMatrix.tp + rMatrix.fp + rMatrix.tn + rMatrix.fn : 0;

    const overallSetup =
      overallSlice && overallSlice.ccm
        ? {
            truePositive: overallSlice.ccm.tp,
            falsePositive: overallSlice.ccm.fp,
            trueNegative: overallSlice.ccm.tn,
            falseNegative: overallSlice.ccm.fn
          }
        : overallOptimized && overallOptimized.setup
          ? overallOptimized.setup
          : rSetup;

    const winRate = rMatrix && nTotal ? rMatrix.tp / nTotal : 0;

    const cWinRate = rightSetup && cTotal ? currentMatrix.tp / cTotal : 0;

    const oldMax = Math.max(cTotal, nTotal);

    const leftColumnWidth = isSmall || strategy ? 160 : 130;

    const cLeads = this.getNewValueCapped(cTotal, oldMax, leftColumnWidth);
    const cOppsValue = currentMatrix.tp + currentMatrix.fp;
    const cOpps = this.getNewValueCapped(cOppsValue, oldMax, leftColumnWidth);
    const cWins = this.getNewValueCapped(currentMatrix.tp, oldMax, leftColumnWidth);

    const nLeads = this.getNewValue(nTotal, oldMax);
    const nOppsValue = rMatrix ? rMatrix.tp + rMatrix.fp : 0;
    const nOpps = this.getNewValue(nOppsValue, oldMax);
    const nWinsValue = rMatrix ? rMatrix.tp : 0;
    const nWins = this.getNewValue(rMatrix ? rMatrix.tp : 0, oldMax);

    const isZoomed = this.state.funnelZoom;
    const cScale = isZoomed && cOpps ? cLeads / cOpps : 1;
    const nScale = isZoomed && nOpps ? nLeads / nOpps : 1;

    const rDelta = optimized
      ? optimized.revenueDelta > 0
        ? (((optimized.revenue - optimized.currentRevenue) / optimized.currentRevenue) * 100).toFixed(1)
        : (((optimized.currentRevenue - optimized.revenue) / optimized.currentRevenue) * 100).toFixed(1)
      : 0;

    const isEmpty = showImpact !== true && setup.showImpact === undefined && setup.showBusiness === undefined;
    const isPercentage = showImpact !== true && setup.showImpact === undefined;

    const cEffort = rightSetup && cTotal ? Math.round(((currentMatrix.tp + currentMatrix.fp) / cTotal) * 100) : 0;
    const nEffort = rMatrix && nTotal ? ((rMatrix.tp + rMatrix.fp) / nTotal) * 100 : 0;

    const activeColor =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId && d.column !== "Overall").length > 0
        ? modelGroups.drilldownValues.filter((d) => d.runId === runId)[0].color
        : "#7E69D7";

    const defaultGrey = showSubgroup ? activeSlice.color : "rgb(204, 204, 204)";

    let currentSegment =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId && d.column == "Overall").length > 0
        ? "Overall"
        : "Optimized";

    const percIncrease = (a, b) => {
      let percent;
      if (b !== 0) {
        if (a !== 0) {
          percent = ((b - a) / a) * 100;
        } else {
          return (
            <span className={styles.iFlex}>
              <span>{"+"}</span>
              <span className={styles.infSymbol}>{"∞"}</span>
            </span>
          );
        }
      } else {
        percent = -a * 100;
      }
      return percent.toFixed(2) + "%";
    };

    const subgroupCostDelta = showSubgroup
      ? optimized && isPercentage
        ? percIncrease(activeSlice.currentCost, activeSlice.cost)
        : optimized.totalCost - optimized.currentSpend &&
          `${optimized.totalCost - optimized.currentSpend > 0 ? "+" : "-"} ${setupLabels.unitType}${numeral(
            Math.abs(optimized.totalCost - optimized.currentSpend)
          ).format("0.0a")}`
      : "";
    const subgroupProfitDelta = showSubgroup
      ? optimized && isPercentage
        ? percIncrease(activeSlice.currentProfit, activeSlice.profit)
        : optimized &&
          optimized.profitDelta &&
          `${optimized.profitDelta > 0 ? "+" : "-"} ${
            setupLabels.unitType
          }${numeral(Math.abs(optimized.profitDelta)).format("0.0a")}`
      : "";
    const subgroupRevenueDelta = showSubgroup
      ? optimized && isPercentage
        ? percIncrease(activeSlice.currentRevenue, activeSlice.revenue)
        : optimized &&
          optimized.revenueDelta &&
          `${optimized.revenueDelta > 0 ? "+" : "-"} ${
            setupLabels.unitType
          }${numeral(Math.abs(optimized.revenueDelta)).format("0.0a")}`
      : "";

    const costDelta =
      isPercentage && overallOptimized
        ? percIncrease(overallOptimized.currentSpend, overallOptimized.totalCost)
        : showSubgroup
          ? overallOptimized && overallOptimized.totalCost - overallOptimized.currentSpend
            ? `${
                overallOptimized.totalCost - overallOptimized.currentSpend > 0 ? "+" : "-"
              } ${setupLabels.unitType}${numeral(
                Math.abs(overallOptimized.totalCost - overallOptimized.currentSpend)
              ).format("0.0a")}`
            : ""
          : optimized && optimized.totalCost - optimized.currentSpend
            ? `${optimized.totalCost - optimized.currentSpend > 0 ? "+" : "-"} ${setupLabels.unitType}${numeral(
                Math.abs(optimized.totalCost - optimized.currentSpend)
              ).format("0.0a")}`
            : "";

    const profitDiffLabel = showSubgroup
      ? overallOptimized && isNaN(overallOptimized.profitDelta)
        ? ""
        : overallOptimized &&
          overallOptimized.profitDelta &&
          `${overallOptimized.profitDelta > 0 ? "+" : "-"} ${
            setupLabels.unitType
          }${numeral(Math.abs(overallOptimized.profitDelta)).format("0.0a")}`
      : optimized && isNaN(optimized.profitDelta)
        ? ""
        : optimized &&
          optimized.profitDelta &&
          `${optimized.profitDelta > 0 ? "+" : "-"} ${
            setupLabels.unitType
          }${numeral(Math.abs(optimized.profitDelta)).format("0.0a")}`;

    const revenueDiffLabel =
      isPercentage && overallOptimized
        ? percIncrease(overallOptimized.currentRevenue, overallOptimized.revenue)
        : showSubgroup
          ? overallOptimized &&
            overallOptimized.revenueDelta &&
            `${overallOptimized.revenueDelta > 0 ? "+" : "-"} ${setupLabels.unitType}${numeral(
              Math.abs(Math.round(overallOptimized.revenueDelta))
            ).format("0.0a")}`
          : optimized &&
            optimized.revenueDelta &&
            `${optimized.revenueDelta > 0 ? "+" : "-"} ${setupLabels.unitType}${numeral(
              Math.abs(Math.round(optimized.revenueDelta))
            ).format("0.0a")}`;
    const allDriversAdded =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter(
        (group) => group && group.setup && group.column !== "Overall" && !group.setup.showImpact
      ).length;

    const numSegments = modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues.length;

    const subgroupCounts = {
      leads: [],
      opps: [],
      wins: []
    };

    const currentSubgroupCounts = {
      leads: [],
      opps: [],
      wins: []
    };

    if (modelGroups && modelGroups.drilldownValues) {
      const otherSegments = modelGroups.drilldownValues.filter((d) => d.value !== "Overall");
      const retSCM = segmentConfusionMatrices || {};
      otherSegments.forEach((currSeg) => {
        const currSCM = retSCM[currSeg.segmentId];
        const currLeads = {
          value: currSCM ? ((currSCM.tp + currSCM.fp + currSCM.fn + currSCM.tn) / (nTotal || 1)) * 100 : 0,
          color: currSeg.color
        };
        const currOpps = {
          value: currSCM ? ((currSCM.tp + currSCM.fp) / (nOpps || 1)) * 100 : 0,
          color: currSeg.color
        };
        const currWins = {
          value: currSCM ? (currSCM.tp / (nWins || 1)) * 100 : 0,
          color: currSeg.color
        };
        subgroupCounts.leads.push(currLeads);
        subgroupCounts.opps.push(currOpps);
        subgroupCounts.wins.push(currWins);

        const baselineMatrix = getBaselineMatrixFromSetup(currSeg?.setup);

        const baselineLeads = {
          value:
            currSeg && currSeg.setup
              ? ((baselineMatrix.tp + baselineMatrix.fp + baselineMatrix.fn + baselineMatrix.tn) / (cTotal || 1)) * 100
              : 0,
          color: currSeg.color
        };
        const baselineOpps = {
          value: currSeg && currSeg.setup ? ((baselineMatrix.tp + baselineMatrix.fp) / (cOpps || 1)) * 100 : 0,
          color: currSeg.color
        };
        const baselineWins = {
          value: currSeg && currSeg.setup ? (baselineMatrix.tp / (cWins || 1)) * 100 : 0,
          color: currSeg.color
        };
        currentSubgroupCounts.leads.push(baselineLeads);
        currentSubgroupCounts.opps.push(baselineOpps);
        currentSubgroupCounts.wins.push(baselineWins);
      });
    }
    const generateBinValue = () => {
      let binValue = 1000;
      const opportunitiesOptimized = rightSetup.truePositive + rightSetup.falsePositive;
      const opportunitiesBaseline = rMatrix ? rMatrix.tp + rMatrix.fp : 0;
      let valuesToJudge = [
        cTotal,
        nTotal,
        opportunitiesOptimized,
        opportunitiesBaseline,
        rightSetup.truePositive,
        rMatrix ? rMatrix.tp : 0
      ];
      let minValue = Math.min(...valuesToJudge);
      if (minValue !== undefined) {
        if (minValue < 100) {
          binValue = 100;
        }
      }
      return binValue;
    };

    const generateBinValueByInput = (input1, input2, total) => {
      let binValue = 1000;

      let valuesToJudge = [input1, input2];
      let minValue = Math.max(...valuesToJudge);

      if (isNaN(minValue)) binValue = 1000;
      else if (minValue < 2000 && minValue >= 200) binValue = 100;
      else if (minValue < 200) binValue = 10;
      else if (minValue !== undefined) {
        binValue = minValue / 20;
      }
      if (total && binValue !== this.state.binsMax) this.setState({ binsMax: binValue });
      return binValue;
    };

    const generateBins = (
      currentValue,
      optimizedValue,
      unusedBinSize = 100,
      extraMargin = 0,
      total = false,
      binLabel = undefined
    ) => {
      if ((optimizedValue === 0 || isNaN(optimizedValue)) && (currentValue === 0 || isNaN(currentValue))) {
        const margin = extraMargin > 0 ? 20 + extraMargin : 40;
        return <div style={{ height: `${margin}px` }}></div>;
      }
      const maxComparison = Math.max(optimizedValue, currentValue);
      const { setupLabels } = this.props;
      // const determineBinSize = generateBinValueByInput(
      //   currentValue,
      //   optimizedValue,
      //   total
      // );
      // const binSize = this.state.binsMax
      //   ? this.state.binsMax
      //   : determineBinSize;
      const scale = currentValue > optimizedValue ? currentValue : optimizedValue;
      //const maxBins = Math.min(20, Math.ceil(scale / binSize));
      const generateBinsRow = (isOptimized, value, addExtraMargin = false) => {
        //const numBins = Math.min(20, Math.ceil(value / binSize));

        //const binsArray = new Array(Math.ceil(numBins)).fill(0);

        const style = isOptimized ? styles.measurementBarOptimized : styles.measurementBarBaseline;

        const containerStyle = isOptimized
          ? styles.measurementBarsContainerOptimized
          : styles.measurementBarsContainerCurrent;

        //const binsToRender = binsArray.length;
        //const binCssSize = 100 / binsToRender;

        // const extraStyles = {
        //   width: `${Math.min(98, (numBins / maxBins) * 100)}%`,
        // };
        const extraStyles = {
          width: `calc(${Math.round((value / maxComparison) * 100)}% - 1px)`
        };
        if (addExtraMargin) {
          extraStyles.marginTop = `${extraMargin}px`;
        }
        return (
          <FunnelTooltip
            tooltipText={
              <div>
                <span style={{ fontWeight: "bold" }}>{`${isOptimized ? "Optimized: " : "Baseline: "}`}</span>
                {Math.round(value).toLocaleString("en-US")}
              </div>
            }
          >
            <div className={containerStyle} style={extraStyles}>
              {/* {binsArray.map((bin, index) => {
                return (
                  <div
                    key={index}
                    className={style}
                    style={{ minWidth: `calc(${binCssSize}% - 1px)` }}
                  ></div>
                );
              })} */}
              <div
                className={style}
                style={{
                  width: `calc(${Math.round((value / maxComparison) * 100)}% - 1px)`
                }}
              ></div>
            </div>
          </FunnelTooltip>
        );
      };
      return (
        <React.Fragment>
          {generateBinsRow(true, optimizedValue, true)}
          {generateBinsRow(false, currentValue)}
          <div
            style={{
              paddingLeft: "3px",
              display: "flex",
              alignItems: "center",
              flexFlow: "column"
            }}
          >
            <div
              style={{
                width: "100%",
                height: "12px",
                display: "flex",
                alignItems: "center",
                marginTop: "3px"
              }}
            >
              <div
                style={{
                  width: `10%`,
                  backgroundColor: "#868595",
                  height: "8px",
                  marginRight: "3px"
                }}
              ></div>
              <div>{`<- ${
                scale < 1000
                  ? Number(Number.parseFloat(scale * 0.1).toPrecision(1)).toLocaleString("en-US")
                  : (Math.round((scale * 0.1) / 100) * 100).toLocaleString("en-US")
              }${binLabel ? " " + binLabel : ""}`}</div>
            </div>
          </div>
        </React.Fragment>
      );
    };

    const isFullHeightModelBox = this.state.viewportHeight > 875;

    //const baselinesEnabled = project && project.settings && project.settings.showBaselines;
    const baselinesEnabled = false;
    return (
      <React.Fragment>
        <div
          className={isSmall ? styles.smallContent : styles.mContent}
          style={
            nextModelsHoverNode?.id === "OPTIMIZE_TRANSACTION" ||
            nextModelsHoverNode?.id === "OPTIMIZE_COSTS" ||
            nextModelsHoverNode?.id === "OPTIMIZE_STRATEGY"
              ? {
                  height: "auto",
                  paddingBottom: "20px",
                  background: "rgba(243, 242, 253, 1)"
                }
              : nextId !== undefined
                ? { height: "auto", paddingBottom: "20px" }
                : {}
          }
        >
          {/*isEmpty === true && (
          <a
            className={isSmall ? styles.eAbsSmall : styles.eAbs}
            onClick={isSmall ? () => {} : () => updateShowBusiness(true)}
          >
            {"Add business objectives to see the optimized effort"}
          </a>
        )*/}

          {overallOnly && (
            <ModelLabels
              mode={mode}
              optimized={optimized}
              setupLabels={setupLabels}
              overallOnly={overallOnly}
              modelGroups={modelGroups}
            />
          )}
          {isSmall === true ? (
            <div />
          ) : setup === undefined ? (
            <div className={styles.mColumn}>{"EMPTY"}</div>
          ) : (
            <div className={strategy ? styles.mColumnCompare : styles.mColumn}>
              <div className={styles.mSubTitle}>{showSubgroup ? activeSlice.value : "Baseline"}</div>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {"Total " + (setupLabels ? setupLabels.notPursuedTransactionLabel : "") + ": "}
                    </span>
                    {Math.round(cTotal).toLocaleString("en-US")}
                  </div>
                }
              >
                <div className={styles.modelBarHolder} style={{ marginTop: "5px" }}>
                  <div
                    className={styles.modelBar + " " + styles.subgroupModels}
                    style={{
                      width: cLeads + "px",
                      background: numSegments > 1 ? "" : defaultGrey,
                      opacity: numSegments > 1 ? 1 : 0.6,
                      transform: `scaleX(${cScale})`
                    }}
                  >
                    {currentSubgroupCounts.leads.map((currSubgroup, i) => (
                      <div
                        key={"subgroup_current_leads" + i}
                        className={styles.subgroupModelBar}
                        style={{
                          width: currSubgroup.value + "%",
                          background: isOverallSegment !== true ? activeSlice?.color + "50" : currSubgroup.color + "50"
                        }}
                      />
                    ))}
                  </div>
                  <div className={styles.modelBarMask} style={{ opacity: isZoomed ? 1 : 0 }} />
                </div>
              </FunnelTooltip>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {setupLabels ? setupLabels.notPursuedTransactionLabel + " " + setupLabels.falseAction + ": " : ""}
                    </span>
                    {setup ? Math.round(currentMatrix.tn + currentMatrix.fn).toLocaleString("en-US") : ""}
                  </div>
                }
              >
                <div className={styles.modelBarHolder}>
                  <div
                    className={styles.modelBar}
                    style={{
                      width: cLeads + "px",
                      borderLeft: (cLeads - cOpps) / 2 + "px solid transparent",
                      borderRight: (cLeads - cOpps) / 2 + "px dotted transparent",
                      borderTop: "40px solid " + defaultGrey,
                      opacity: 0.2,
                      transform: `scaleX(${cScale})`
                    }}
                  />
                  <div className={styles.modelBarMask} style={{ opacity: isZoomed ? 1 : 0 }} />
                </div>
              </FunnelTooltip>

              <div className={styles.modelBarHolder}>
                <FunnelTooltip
                  tooltipText={
                    <div>
                      <span style={{ fontWeight: "700" }}>
                        {(setupLabels ? setupLabels.transactionLabel + " to " + setupLabels.trueAction : "Total") +
                          ": "}
                      </span>
                      {Math.round(rightSetup.truePositive + rightSetup.falsePositive).toLocaleString("en-US")}
                    </div>
                  }
                >
                  <div
                    className={styles.modelBar + " " + styles.subgroupModels}
                    style={{
                      width: cOpps * cScale + "px",
                      background: numSegments > 1 ? "" : defaultGrey,
                      opacity: numSegments > 1 ? 1 : 0.8
                    }}
                  >
                    {currentSubgroupCounts.opps.map((currSubgroup, i) => (
                      <div
                        key={"subgroup_current_opportunities" + i}
                        className={styles.subgroupModelBar}
                        style={{
                          width: currSubgroup.value + "%",
                          background: isOverallSegment !== true ? activeSlice?.color + "50" : currSubgroup.color + "50"
                        }}
                      />
                    ))}
                  </div>
                </FunnelTooltip>
              </div>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {(setupLabels ? setupLabels.transactionLabel : "") +
                        " not " +
                        (setupLabels ? setupLabels.outcomeLabel + ": " : "")}
                    </span>
                    {setup ? Math.round(currentMatrix.fp).toLocaleString("en-US") : ""}
                  </div>
                }
              >
                <div className={styles.modelBarHolder}>
                  <div
                    className={styles.modelBar}
                    style={{
                      width: cOpps * cScale + "px",
                      borderLeft: ((cOpps - cWins) / 2) * cScale + "px solid transparent",
                      borderRight: ((cOpps - cWins) / 2) * cScale + "px dotted transparent",
                      borderTop: "40px solid " + defaultGrey,
                      opacity: 0.3
                    }}
                  />
                </div>
              </FunnelTooltip>
              <div className={styles.modelBarHolder}>
                <FunnelTooltip
                  tooltipText={
                    <div>
                      <span style={{ fontWeight: "700" }}>
                        {setupLabels ? setupLabels.transactionLabel + " " + setupLabels.outcomeLabel + ": " : ""}
                      </span>
                      {Math.round(currentMatrix.tp).toLocaleString("en-US")}
                    </div>
                  }
                >
                  <div
                    className={styles.modelBar + " " + styles.subgroupModels}
                    style={{
                      width: cWins * cScale + "px",
                      background: numSegments > 1 ? "" : defaultGrey
                    }}
                  >
                    {currentSubgroupCounts.wins.map((currSubgroup, i) => (
                      <div
                        key={"subgroup_current_wins" + i}
                        className={styles.subgroupModelBar}
                        style={{
                          width: currSubgroup.value + "%",
                          background: isOverallSegment !== true ? activeSlice?.color + "50" : currSubgroup.color + "50"
                        }}
                      />
                    ))}
                  </div>
                </FunnelTooltip>
              </div>
              {isPercentage !== true && isEmpty !== true ? (
                isFullHeightModelBox ? (
                  <div
                    className={styles.mInfoDonut}
                    style={{
                      paddingTop: "45px",
                      marginTop: "25px"
                    }}
                  >
                    <span className={styles.mPieLabel}>
                      {unitType +
                        (optimized
                          ? numeral(showSubgroup ? activeSlice.totalCost : optimized.currentSpend).format("0.0a")
                          : numeral(
                              Math.abs((setup?.truePositive + setup.falsePositive) * setup.conversionCost)
                            ).format("0.0a"))}
                      {showSubgroup && <span className={styles.mMedium}>{subgroupCostDelta}</span>}
                    </span>
                    <div
                      className={styles.donutContainer}
                      style={{
                        top: "-5px"
                      }}
                    >
                      {this.renderPieChart("currentSpend", false)}
                    </div>
                  </div>
                ) : (
                  <div className={styles.mInfoMinified}>
                    <span className={styles.mPieLabel}>
                      {optimized &&
                        unitType +
                          (optimized
                            ? numeral(showSubgroup ? activeSlice.totalCost : optimized.currentSpend).format("0.0a")
                            : "")}
                      {showSubgroup && <span className={styles.mMedium}>{subgroupCostDelta}</span>}
                    </span>
                    <div
                      className={styles.minifiedSegmentsBar}
                      style={{
                        top: "-5px"
                      }}
                    >
                      {this.renderPieChart("currentSpend", false, isFullHeightModelBox)}
                    </div>
                  </div>
                )
              ) : (
                <div className={styles.mInfo}>
                  <span className={styles.mLargeGray}>
                    {cEffort.toFixed(2) + "%"}
                    {showSubgroup && <span className={styles.mMedium}>{subgroupCostDelta}</span>}
                  </span>
                </div>
              )}
              {isPercentage || isEmpty ? (
                <div className={styles.mInfo}>
                  <span className={styles.mLargeGray}>
                    {(isNaN(cWinRate) ? 0 : (cWinRate * 100).toFixed(2)) + "%"}
                    {showSubgroup && <span className={styles.mMedium}>{subgroupRevenueDelta}</span>}
                  </span>
                </div>
              ) : isFullHeightModelBox ? (
                <div className={styles.mInfoDonut} style={{ marginTop: "28px" }}>
                  <span className={styles.mPieLabel}>
                    {isPercentage === true
                      ? "100%"
                      : unitType +
                        (optimized
                          ? numeral(showSubgroup ? activeSlice.revenue : optimized.currentRevenue).format("0.0a")
                          : numeral(
                              setup?.truePositive * (Math.abs(setup?.conversionCost) + setup.conversionGain)
                            ).format("0.0a"))}
                    {showSubgroup && <span className={styles.mMedium}>{subgroupRevenueDelta}</span>}
                  </span>
                  <div className={styles.donutContainer} style={{ top: "-10px" }}>
                    {this.renderPieChart("currentRevenue", false)}
                  </div>
                </div>
              ) : (
                <div className={styles.mInfoMinified}>
                  <span className={styles.mPieLabel}>
                    {isPercentage === true
                      ? "100%"
                      : optimized
                        ? unitType +
                          (optimized
                            ? numeral(showSubgroup ? activeSlice.revenue : optimized.currentRevenue).format("0.0a")
                            : "")
                        : ""}
                    {showSubgroup && <span className={styles.mMedium}>{subgroupRevenueDelta}</span>}
                  </span>
                  <div
                    className={styles.minifiedSegmentsBar}
                    style={{
                      top: "-5px"
                    }}
                  >
                    {this.renderPieChart("currentRevenue", false, isFullHeightModelBox)}
                  </div>
                </div>
              )}
              {
                /*allDriversAdded === 0 && numSegments > 1) ||
                ((numSegments === 1 || currentSegment !== "Overall") &&*/
                isPercentage !== true &&
                  isEmpty !== true &&
                  (isFullHeightModelBox ? (
                    <div
                      className={styles.mInfoDonut}
                      style={
                        {
                          //height: "unset",
                        }
                      }
                    >
                      <span className={styles.mPieLabel}>
                        {unitType +
                          (optimized
                            ? numeral(showSubgroup ? activeSlice.profit : optimized.currentProfit).format("0.0a")
                            : numeral(
                                setup?.truePositive * setup?.conversionGain +
                                  setup?.falsePositive * setup?.conversionCost
                              ).format("0.0a"))}
                        {showSubgroup && <span className={styles.mMedium}>{subgroupProfitDelta}</span>}
                      </span>
                      <div className={styles.donutContainer} style={{ top: "-10px" }}>
                        {this.renderPieChart("currentProfit", false)}
                      </div>
                    </div>
                  ) : (
                    <div className={styles.mInfoMinified}>
                      <span className={styles.mPieLabel}>
                        {optimized &&
                          unitType +
                            (optimized
                              ? numeral(showSubgroup ? activeSlice.profit : optimized.currentProfit).format("0.0a")
                              : "")}
                        {showSubgroup && <span className={styles.mMedium}>{subgroupProfitDelta}</span>}
                      </span>
                      <div
                        className={styles.minifiedSegmentsBar}
                        style={{
                          top: "-5px"
                        }}
                      >
                        {this.renderPieChart("currentProfit", false, isFullHeightModelBox)}
                      </div>
                    </div>
                  ))
              }
            </div>
          )}
          {
            <div className={isSmall ? styles.mColumn : strategy ? styles.mColumnCompare : styles.mColumn}>
              <div className={isNext ? styles.nextMMiddle : styles.mMiddle} style={{ marginTop: "21px" }}>
                {setupLabels.notPursuedTransactionLabel}
              </div>
              {generateBins(cTotal, nTotal, 1000, 0, true, setupLabels.notPursuedTransactionLabel)}
              <div
                className={isNext ? styles.nextMMiddle : styles.mMiddle}
                style={{
                  height: "19px",
                  marginLeft: "6px",
                  marginRight: "6px",
                  marginTop: "28px"
                }}
              >
                <div>{setupLabels.transactionLabel + " to " + setupLabels.trueAction}</div>
                {/* <a
                  className={styles.mLink}
                  onClick={() =>
                    this.setState({ funnelZoom: !this.state.funnelZoom })
                  }
                >
                  <FontAwesomeIcon
                    style={{ marginRight: "6px" }}
                    icon={
                      this.state.funnelZoom
                        ? faCompressArrowsAlt
                        : faExpandArrowsAlt
                    }
                  />
                  {setupLabels.transactionLabel +
                    " to " +
                    setupLabels.trueAction}
                </a> */}
              </div>
              {generateBins(
                currentMatrix.tp + currentMatrix.fp,
                rMatrix ? rMatrix.tp + rMatrix.fp : 0,
                1000,
                undefined,
                undefined,
                setupLabels.transactionLabel
              )}
              <div className={isNext ? styles.nextMMiddle : styles.mMiddle} style={{ marginTop: "28px" }}>
                {setupLabels.outcomeLabel}
              </div>
              {generateBins(
                currentMatrix.tp,
                rMatrix ? rMatrix.tp : 0,
                1000,
                undefined,
                undefined,
                setupLabels.transactionLabel
              )}
              <div
                className={styles.mMiddle}
                style={
                  isNext
                    ? { marginTop: isFullHeightModelBox ? "25px" : "15px" }
                    : showDelta || isSmall
                      ? { marginTop: "52px" }
                      : { marginTop: "60px" }
                }
              >
                <div>
                  {isPercentage !== true && isEmpty !== true ? setupLabels.costLabel : setupLabels.costLabel + " %"}
                  {showDelta && (
                    <span className={styles.mMedium}>
                      {isPercentage !== true && isEmpty !== true && costDelta !== undefined
                        ? costDelta
                        : (nEffort > cEffort ? "+" : "-") + "" + Math.abs(nEffort - cEffort).toFixed(2) + "%"}
                    </span>
                  )}
                </div>
                {this.renderBadges("cost")}
              </div>
              {overallOptimized ? (
                <React.Fragment>
                  <div
                    className={styles.mMiddle + " " + (isNext && isFullHeightModelBox ? styles.isLarge : "")}
                    style={{ marginTop: "0px", marginLeft: "-5px" }}
                  >
                    <span className={styles.mMedium + " " + (isNext && isFullHeightModelBox ? styles.isLarge : "")}>
                      {isPercentage !== true && isEmpty !== true && costDelta !== undefined
                        ? costDelta
                        : (nEffort > cEffort ? "+" : "-") + "" + Math.abs(nEffort - cEffort).toFixed(2) + "%"}
                    </span>
                  </div>
                  <div className={styles.mMiddleBar}>
                    <TinyBarChart
                      bars={[
                        {
                          label: "Optimal " + overallOptimized.resourcingLabel,
                          Cost: optimized.totalCost
                        },
                        {
                          label: "Baseline " + overallOptimized.resourcingLabel,
                          Cost: optimized.currentSpend
                        }
                      ]}
                      unit={overallOptimized.unitLabel}
                      isCurrencyUnit={overallOptimized.isCurrencyUnitType}
                      hideText
                      //hideTooltip
                      barChartHeight={20}
                      noMargin={true}
                    />
                  </div>
                </React.Fragment>
              ) : (
                <div style={{ height: "38px" }}></div>
              )}
              {isEmpty === true || isPercentage === true ? (
                <div className={styles.mMiddle} style={isSmall ? { marginTop: "44px" } : { marginTop: "60px" }}>
                  <div>
                    {setupLabels.outcomeLabel + " %"}
                    <span className={styles.mMedium}>
                      {showDelta
                        ? (winRate * 100 > cWinRate * 100 ? "+" : "-") +
                          "" +
                          Math.abs(winRate * 100 - cWinRate * 100).toFixed(2) +
                          "%"
                        : " "}
                    </span>
                  </div>
                  {this.renderBadges("revenue")}
                </div>
              ) : (
                <React.Fragment>
                  <div
                    className={styles.mMiddle}
                    style={
                      isNext
                        ? { marginTop: isFullHeightModelBox ? "55px" : "0px" }
                        : isSmall
                          ? { marginTop: "44px" }
                          : { marginTop: "62px" }
                    }
                  >
                    <div>
                      {setupLabels.revenueLabel}
                      {showDelta && (
                        <span className={styles.mMedium}>
                          {
                            revenueDiffLabel
                            /*optimized.revenueDelta > 0
                      ? (
                          ((optimized.revenue - optimized.currentRevenue) /
                            Math.abs(optimized.currentRevenue)) *
                          100
                        ).toFixed(1) + "%"
                      : "-" +
                        (
                          ((optimized.currentRevenue - optimized.revenue) /
                            Math.abs(optimized.currentRevenue)) *
                          100
                        ).toFixed(1) +
                        "%"*/
                          }
                        </span>
                      )}
                    </div>
                    {this.renderBadges("revenue")}
                  </div>
                  {overallOptimized ? (
                    <React.Fragment>
                      <div
                        className={styles.mMiddle + " " + (isNext && isFullHeightModelBox ? styles.isLarge : "")}
                        style={{ marginTop: "0px", marginLeft: "-5px" }}
                      >
                        <span className={styles.mMedium + " " + (isNext && isFullHeightModelBox ? styles.isLarge : "")}>
                          {isNaN(revenueDiffLabel) && typeof revenueDiffLabel !== "string" ? "" : revenueDiffLabel}
                        </span>
                      </div>
                      <div className={styles.mMiddleBar}>
                        <TinyBarChart
                          bars={[
                            {
                              label: "Optimal " + overallOptimized.revenueLabel,
                              Cost: optimized.revenue
                            },
                            {
                              label: "Baseline " + overallOptimized.revenueLabel,
                              Cost: optimized.currentRevenue
                            }
                          ]}
                          unit={overallOptimized.unitLabel}
                          isCurrencyUnit={overallOptimized.isCurrencyUnitType}
                          hideText
                          //hideTooltip
                          barChartHeight={20}
                          noMargin={true}
                        />
                      </div>
                    </React.Fragment>
                  ) : (
                    <div style={{ height: "38px" }}></div>
                  )}
                </React.Fragment>
              )}
              {
                //(!allDriversAdded || !isOverallSegment) &&
                isPercentage !== true && isEmpty !== true && (
                  <React.Fragment>
                    <div
                      className={styles.mMiddle}
                      style={{
                        marginTop: isNext ? (isFullHeightModelBox ? "65px" : "0px") : isSmall ? "44px" : "62px",
                        height: "unset"
                      }}
                    >
                      <div>
                        {setupLabels.profitLabel}
                        {showDelta && (
                          <span className={styles.mMedium}>
                            {
                              profitDiffLabel

                              /*optimized.profitDelta > 0
                      ? (
                          ((optimized.profit - optimized.currentProfit) /
                            Math.abs(optimized.currentProfit)) *
                          100
                        ).toFixed(1) + "%"
                      : "-" +
                        (
                          ((optimized.currentProfit - optimized.profit) /
                            Math.abs(optimized.currentProfit)) *
                          100
                        ).toFixed(1) +
                        "%"*/
                            }
                          </span>
                        )}
                      </div>
                      {this.renderBadges("profit")}
                    </div>
                    {overallOptimized ? (
                      <React.Fragment>
                        <div
                          className={styles.mMiddle + " " + (isNext && isFullHeightModelBox ? styles.isLarge : "")}
                          style={{ marginTop: "0px", marginLeft: "-5px" }}
                        >
                          <span
                            className={styles.mMedium + " " + (isNext && isFullHeightModelBox ? styles.isLarge : "")}
                          >
                            {profitDiffLabel}
                          </span>
                        </div>
                        <div className={styles.mMiddleBar}>
                          <TinyBarChart
                            bars={[
                              {
                                label: "Optimal " + overallOptimized.profitLabel,
                                Cost: optimized.profit
                              },
                              {
                                label: "Baseline " + overallOptimized.profitLabel,
                                Cost: optimized.currentProfit
                              }
                            ]}
                            unit={overallOptimized.unitLabel}
                            isCurrencyUnit={overallOptimized.isCurrencyUnitType}
                            hideText
                            //hideTooltip
                            barChartHeight={20}
                            noMargin={true}
                          />
                        </div>
                      </React.Fragment>
                    ) : (
                      <div style={{ height: "38px" }}></div>
                    )}
                  </React.Fragment>
                )
              }
            </div>
          }
          <div
            className={isSmall ? styles.mColumnFull : strategy ? styles.mColumnFullCompare : styles.mColumn}
            style={overallOnly ? { width: "calc(100% - 145px" } : {}}
          >
            {!comparisonOptions ? (
              <div className={styles.mSubTitle}>{"Aible Optimized"}</div>
            ) : (
              <Tooltip
                trigger={["hover"]}
                overlay={
                  <div className={styles.mSubTitleTooltip}>
                    <div>
                      {`This AI was trained on data where ${comparisonOptions?.dateField} is on or after ${comparisonOptions?.referenceStart} and ` +
                        `${comparisonOptions?.referenceEnd === comparisonOptions?.currentStart ? "before" : "on or before"} ${comparisonOptions?.referenceEnd}.`}
                    </div>
                    <div style={{ marginTop: "5px" }}>
                      {`It was then evaluated using data on or after ${comparisonOptions?.currentStart} and on or before ${comparisonOptions?.currentEnd}`}
                    </div>
                  </div>
                }
              >
                <div className={styles.mSubTitleTestTrainWrapper}>
                  <div className={styles.mSubTitleTestTrainTitle}>{"Aible Optimized"}</div>
                  <div className={styles.mSubTitleTestTrainText}>
                    {`Tested on ${comparisonOptions?.dateField} between ${comparisonOptions?.currentStart} and ${comparisonOptions?.currentEnd}`}
                  </div>
                </div>
              </Tooltip>
            )}
            <FunnelTooltip
              tooltipText={
                <div>
                  <span style={{ fontWeight: "700" }}>
                    {"Total " + (setupLabels ? setupLabels.notPursuedTransactionLabel : "") + ": "}
                  </span>
                  {Math.round(nTotal).toLocaleString("en-US")}
                </div>
              }
            >
              <div className={styles.modelBarHolder} style={{ marginTop: "5px" }}>
                <div
                  className={styles.modelBar + " " + styles.subgroupModels}
                  style={{
                    width: nLeads + "px",
                    background: activeColor,
                    opacity: 0.6,
                    transform: `scaleX(${nScale})`
                  }}
                >
                  {subgroupCounts.leads.map((currSubgroup, i) => (
                    <div
                      key={"subgroup_current_leads" + i}
                      className={styles.subgroupModelBar}
                      style={{
                        width: currSubgroup.value + "%",
                        background: isOverallSegment !== true ? activeSlice?.color : currSubgroup.color
                      }}
                    />
                  ))}
                </div>

                <div className={styles.modelBarMask} style={{ opacity: isZoomed ? 1 : 0 }} />
              </div>
            </FunnelTooltip>
            <FunnelTooltip
              tooltipText={
                <div>
                  <span style={{ fontWeight: "700" }}>
                    {setupLabels ? setupLabels.notPursuedTransactionLabel + " " + setupLabels.falseAction + ": " : ""}
                  </span>
                  {rMatrix ? Math.round(rMatrix.tn + rMatrix.fn).toLocaleString("en-US") : ""}
                </div>
              }
            >
              <div className={styles.modelBarHolder}>
                <div
                  className={styles.modelBar}
                  style={{
                    width: nLeads + "px",
                    borderLeft: (nLeads - nOpps) / 2 + "px solid transparent",
                    borderRight: (nLeads - nOpps) / 2 + "px dotted transparent",
                    borderTop: " 40px solid " + activeColor,
                    opacity: 0.2,
                    transform: `scaleX(${nScale})`
                  }}
                />
                <div className={styles.modelBarMask} style={{ opacity: isZoomed ? 1 : 0 }} />
              </div>
            </FunnelTooltip>
            <div className={styles.modelBarHolder}>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {(setupLabels ? setupLabels.transactionLabel + " to " + setupLabels.trueAction : "Total") + ": "}
                    </span>
                    {rMatrix ? Math.round(rMatrix.tp + rMatrix.fp).toLocaleString("en-US") : 0}
                  </div>
                }
              >
                <div
                  className={styles.modelBar + " " + styles.subgroupModels}
                  style={{
                    width: nOpps * nScale + "px",
                    background: activeColor,
                    opacity: 0.8
                  }}
                >
                  {subgroupCounts.opps.map((currSubgroup, i) => (
                    <div
                      key={"subgroup_current_opps" + i}
                      className={styles.subgroupModelBar}
                      style={{
                        width: currSubgroup.value + "%",
                        background: isOverallSegment !== true ? activeSlice?.color : currSubgroup.color
                      }}
                    />
                  ))}
                </div>
              </FunnelTooltip>
            </div>
            <FunnelTooltip
              tooltipText={
                <div>
                  <span style={{ fontWeight: "700" }}>
                    {(setupLabels ? setupLabels.transactionLabel : "") +
                      " not " +
                      (setupLabels ? setupLabels.outcomeLabel + ": " : "")}
                  </span>
                  {rMatrix ? Math.round(rMatrix.fp).toLocaleString("en-US") : ""}
                </div>
              }
            >
              <div className={styles.modelBarHolder}>
                <div
                  className={styles.modelBar}
                  style={{
                    width: nOpps * nScale + "px",
                    borderLeft: ((nOpps - nWins) / 2) * nScale + "px solid transparent",
                    borderRight: ((nOpps - nWins) / 2) * nScale + "px dotted transparent",
                    borderTop: " 40px solid " + activeColor,
                    opacity: 0.3
                  }}
                />
              </div>
            </FunnelTooltip>
            <div className={styles.modelBarHolder}>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {setupLabels ? setupLabels.transactionLabel + " " + setupLabels.outcomeLabel + ": " : ""}
                    </span>
                    {rMatrix ? Math.round(rMatrix.tp).toLocaleString("en-US") : 0}
                  </div>
                }
              >
                <div
                  className={styles.modelBar + " " + styles.subgroupModels}
                  style={{
                    width: nWins * nScale + "px",
                    background: activeColor
                  }}
                >
                  {subgroupCounts.wins.map((currSubgroup, i) => (
                    <div
                      key={"subgroup_current_wins" + i}
                      className={styles.subgroupModelBar}
                      style={{
                        width: currSubgroup.value + "%",
                        background: isOverallSegment !== true ? activeSlice?.color : currSubgroup.color
                      }}
                    />
                  ))}
                </div>
              </FunnelTooltip>
            </div>
            {
              //end of funnel
              (optimized && optimized.bestModel && (isPercentage || isEmpty)) || optimized?.isCreating ? (
                nTotal === 0 && isTraining ? (
                  <div className={styles.funnelLoadingContainer}>
                    <LoadingIndicator
                      style={{
                        margin: "0px",
                        top: "-125px"
                        //left: isSmall || showSubgroup ? "133px" : "40px",
                      }}
                    />
                  </div>
                ) : (
                  <div
                    className={styles.mInfoRight}
                    style={{
                      marginTop: isSmall || showSubgroup ? "60px" : "47px"
                    }}
                  >
                    {isOptimizerRunning ? (
                      false && (
                        <LoadingIndicator
                          style={{
                            margin: "0px",
                            marginLeft: "40px",
                            marginTop: "-15px"
                          }}
                        />
                      )
                    ) : (
                      <span className={styles.mLarge}>{nEffort.toFixed(2) + "%"}</span>
                    )}
                    {!showDelta && !isNext && (
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <div className={styles.labelBarChart} style={{ marginLeft: "15px" }}>
                          <TinyBarChart
                            bars={[
                              {
                                label: "Optimal " + overallOptimized.resourcingLabel,
                                Cost: nEffort
                              },
                              {
                                label: "Baseline " + overallOptimized.resourcingLabel,
                                Cost: nEffort - parseFloat(costDelta)
                              }
                            ]}
                            unit={"%"}
                            hideText
                            barChartHeight={20}
                          />
                          {/*<span className={styles.mMedium}>{costDelta}</span>*/}
                        </div>
                      </div>
                    )}
                  </div>
                )
              ) : optimized && optimized.bestModel ? (
                <div
                  className={isFullHeightModelBox ? styles.mInfoDonut : styles.mInfoMinified}
                  style={
                    isFullHeightModelBox
                      ? {
                          paddingTop: "45px",
                          marginTop: "25px"
                        }
                      : {}
                  }
                >
                  {isOptimizerRunning ? (
                    <LoadingIndicator
                      style={{
                        margin: "0px",
                        marginLeft: currentStep === "BUSINESS_OPTIMIZATION" || optimized?.isCreating ? "40px" : "130px",
                        marginTop: "-15px"
                      }}
                    />
                  ) : (
                    <span className={styles.mPieLabel}>
                      {unitType +
                        (optimized
                          ? numeral(showSubgroup ? overallSlice.totalCost : optimized.totalCost).format("0.0a")
                          : "")}
                    </span>
                  )}
                  <div
                    className={isFullHeightModelBox ? styles.donutContainer : styles.minifiedSegmentsBar}
                    style={{ top: "-5px" }}
                  >
                    {this.renderPieChart("totalCost", true, isFullHeightModelBox)}
                  </div>
                  {!showDelta && isOptimizerRunning !== true && !isNext && (
                    <div className={styles.labelBottomOverallSection}>
                      <span className={styles.mMedium + " " + styles.labelBottomSection}>{costDelta}</span>
                      <div className={styles.labelBarChart}>
                        <TinyBarChart
                          bars={[
                            {
                              label: "Optimal " + overallOptimized.resourcingLabel,
                              Cost: overallOptimized.totalCost
                            },
                            {
                              label: "Baseline " + overallOptimized.resourcingLabel,
                              Cost: overallOptimized.currentSpend
                            }
                          ]}
                          unit={overallOptimized.unitLabel}
                          isCurrencyUnit={overallOptimized.isCurrencyUnitType}
                          hideText
                          barChartHeight={20}
                        />
                      </div>
                    </div>
                  )}
                </div>
              ) : optimized && Object.keys(ignoredModels ?? {}).length !== modelList?.length ? (
                <LoadingIndicator
                  style={{
                    margin: "0px",
                    top: "-125px",
                    left: isSmall || showSubgroup ? "133px" : "40px"
                  }}
                />
              ) : (
                <div />
              )
            }
            {optimized && optimized.bestModel && (isPercentage || isEmpty) ? (
              nTotal === 0 && isTraining ? (
                false && (
                  <LoadingIndicator
                    style={{
                      margin: "0px",
                      left: isSmall || showSubgroup ? "133px" : "40px",
                      top: "0px"
                    }}
                  />
                )
              ) : (
                <div className={styles.mInfoRight} style={isSmall ? { marginTop: "27px" } : {}}>
                  {isOptimizerRunning ? (
                    <LoadingIndicator
                      style={{
                        margin: "0px",
                        marginLeft: currentStep === "BUSINESS_OPTIMIZATION" ? "40px" : "130px",
                        marginTop: "-15px"
                      }}
                    />
                  ) : (
                    <span className={styles.mLarge}>{(winRate * 100).toFixed(2) + "%"}</span>
                  )}
                  {!showDelta && isOptimizerRunning !== true && !isNext && (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <div className={styles.labelBarChart} style={{ marginLeft: "15px" }}>
                        <TinyBarChart
                          bars={[
                            {
                              label: "Optimal " + setupLabels.outcomeLabel,
                              Cost: winRate * 100
                            },
                            {
                              label: "Baseline " + setupLabels.outcomeLabel,
                              Cost: (winRate * 100) / ((parseFloat(revenueDiffLabel) + 100) / 100)
                            }
                          ]}
                          unit={"%"}
                          hideText
                          barChartHeight={20}
                        />
                      </div>
                      {/*<span className={styles.mMedium}>{revenueDiffLabel}</span>*/}
                    </div>
                  )}
                </div>
              )
            ) : optimized && optimized.bestModel ? (
              <div
                className={isFullHeightModelBox ? styles.mInfoDonut : styles.mInfoMinified}
                style={{
                  marginTop: isSmall ? "27px" : ""
                }}
              >
                {isOptimizerRunning ? (
                  <LoadingIndicator
                    style={{
                      margin: "0px",
                      marginLeft: currentStep === "BUSINESS_OPTIMIZATION" ? "40px" : "130px",
                      marginTop: "-15px"
                    }}
                  />
                ) : optimized?.isCreating ? (
                  <div />
                ) : (
                  <span className={styles.mPieLabel}>
                    {isPercentage === true
                      ? Math.round(100 - rDelta) + "%"
                      : unitType + numeral(showSubgroup ? overallSlice.revenue : optimized.revenue).format("0.0a")}
                  </span>
                )}
                <div
                  className={isFullHeightModelBox ? styles.donutContainer : styles.minifiedSegmentsBar}
                  style={{ top: "-10px" }}
                >
                  {this.renderPieChart("revenue", true, isFullHeightModelBox)}
                </div>
                {!showDelta && isOptimizerRunning !== true && !isNext && (
                  <div className={styles.labelBottomOverallSection}>
                    <span className={styles.mMedium + " " + styles.labelBottomSection}>
                      {
                        revenueDiffLabel
                        /*optimized.revenueDelta > 0
                    ? (
                        ((optimized.revenue - optimized.currentRevenue) /
                          optimized.currentRevenue) *
                        100
                      ).toFixed(1) + "%"
                    : "-" +
                      (
                        ((optimized.currentRevenue - optimized.revenue) /
                          optimized.currentRevenue) *
                        100
                      ).toFixed(1) +
                      "%"*/
                      }
                    </span>
                    <div className={styles.labelBarChart}>
                      <TinyBarChart
                        bars={[
                          {
                            label: "Optimal " + overallOptimized.revenueLabel,
                            Cost: overallOptimized.revenue
                          },
                          {
                            label: "Baseline " + overallOptimized.revenueLabel,
                            Cost: overallOptimized.currentRevenue
                          }
                        ]}
                        unit={overallOptimized.unitLabel}
                        isCurrencyUnit={overallOptimized.isCurrencyUnitType}
                        hideText
                        barChartHeight={20}
                      />
                    </div>
                  </div>
                )}
              </div>
            ) : optimized ? (
              false && (
                <LoadingIndicator
                  style={{
                    margin: "0px",
                    left: isSmall || showSubgroup ? "133px" : "40px",
                    top: "0px"
                  }}
                />
              )
            ) : (
              <div />
            )}
            {optimized &&
            optimized.bestModel /*allDriversAdded === 0 && numSegments > 1) ||
              ((numSegments === 1 || currentSegment !== "Overall") &&*/ &&
            isPercentage !== true &&
            isEmpty !== true ? (
              /*isPercentage !== true &&
          isEmpty !== true*/
              <div
                className={isFullHeightModelBox ? styles.mInfoDonut : styles.mInfoMinified}
                style={
                  {
                    //height: "unset",
                  }
                }
              >
                {isPercentage !== true && (
                  <span className={styles.mPieLabel}>
                    {isOptimizerRunning ? (
                      <LoadingIndicator
                        style={{
                          margin: "0px"
                        }}
                      />
                    ) : optimized?.isCreating ? (
                      <div />
                    ) : (
                      <React.Fragment>
                        {unitType + numeral(showSubgroup ? overallSlice.profit : optimized.profit).format("0.0a")}
                      </React.Fragment>
                    )}
                  </span>
                )}
                <div
                  className={isFullHeightModelBox ? styles.donutContainer : styles.minifiedSegmentsBar}
                  style={{
                    top: "-10px"
                  }}
                >
                  {this.renderPieChart("profit", true, isFullHeightModelBox)}
                </div>
                {(showSubgroup || isOverallSegment) &&
                  !showDelta &&
                  isOptimizerRunning !== true &&
                  ((allDriversAdded === 0 && numSegments > 1) ||
                    ((numSegments === 1 || currentSegment !== "Overall") &&
                      isPercentage !== true &&
                      isEmpty !== true)) &&
                  !isNext && (
                    <div className={styles.labelBottomOverallSection}>
                      <span className={styles.mMedium + " " + styles.labelBottomSection}>
                        {
                          profitDiffLabel
                          /*optimized.profitDelta > 0
                    ? (
                        ((optimized.profit - optimized.currentProfit) /
                          Math.abs(optimized.currentProfit)) *
                        100
                      ).toFixed(1) + "%"
                    : "-" +
                      (
                        ((optimized.currentProfit - optimized.profit) /
                          Math.abs(optimized.currentProfit)) *
                        100
                      ).toFixed(1) +
                      "%"*/
                        }
                      </span>
                      <div className={styles.labelBarChart}>
                        <TinyBarChart
                          bars={[
                            {
                              label: "Optimal " + overallOptimized.profitLabel,
                              Cost: overallOptimized.profit
                            },
                            {
                              label: "Baseline " + overallOptimized.profitLabel,
                              Cost: overallOptimized.currentProfit
                            }
                          ]}
                          unit={overallOptimized.unitLabel}
                          isCurrencyUnit={overallOptimized.isCurrencyUnitType}
                          hideText
                          barChartHeight={20}
                        />
                      </div>
                    </div>
                  )}
              </div>
            ) : optimized && isPercentage !== true && isEmpty !== true && allDriversAdded === 0 ? (
              false && <LoadingIndicator style={{ margin: "0px", left: "40px", top: "50px" }} />
            ) : (
              <div />
            )}
          </div>
        </div>
        {(isPercentage === true || isEmpty === true) &&
          !isOverallSegment &&
          !businessAssumptions &&
          ((allDriversAdded >
            (modelGroups && modelGroups.drilldownValues ? modelGroups.drilldownValues.length - 1 : 0) &&
            currentSegment === "Overall") ||
            ((currentSegment !== "Overall" || numSegments === 1) && isPercentage === true)) &&
          true && (
            <a
              className={isSmall ? styles.pAbsSmall : styles.pAbs}
              onClick={() => {
                if (currentStep !== UNIFIED_PROJECT_STEPS.BUSINESS_STRATEGY.id) {
                  updateCurrentStep(UNIFIED_PROJECT_STEPS.BUSINESS_STRATEGY.id);
                }
                updateShowImpact(true);
              }}
              style={{
                display: "flex",
                flexFlow: "row noWrap",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer"
              }}
            >
              {primaryBusinessConstraintType ? (
                <img src={WarningIcon} className={styles.lightningIcon} style={{ background: "#F8CD7E" }} />
              ) : (
                <img src={LightningBoltIcon} className={styles.lightningIcon} style={{}} />
              )}
              <span>{"Add business drivers to optimize " + setupLabels.profitLabel}</span>
            </a>
          )}
      </React.Fragment>
    );
  }

  renderModel() {
    const { optimized, modelGroups, rSetup, modelList, runId } = this.props;

    const activeSlice =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.runId === runId)[0]
        : undefined;

    const activeColor = activeSlice ? activeSlice.color : "#7E69D7";

    const setup = optimized ? optimized.setup : rSetup;

    const model = optimized && optimized.bestModel ? optimized.bestModel : {};

    const maxRevenue = this.getMaxRevenue(modelList);
    const minRevenue = this.getMinRevenue(modelList);

    const nRevenue = this.getNewValueBar(
      model.maxIteration.truePositive * setup.conversionGain,
      minRevenue,
      maxRevenue
    );

    const nCost = this.getNewValueBar(
      Math.abs((model.maxIteration.truePositive + model.maxIteration.falsePositive) * setup.conversionCost),
      this.getMinCost(modelList),
      this.getMaxCost(modelList)
    );

    return (
      <div className={styles.modelContent}>
        <div className={styles.modelHeader} style={{ background: activeColor }}>
          <div className={styles.hTop}>{numeral(optimized.profit).format("0.0a")}</div>
          <div className={styles.modelBadgeHolder}>
            <img src={CrownIcon} className={styles.modelIcon} />
            <div className={styles.mOpt}>{"Optimal"}</div>
          </div>
          <div className={styles.hBot}>{optimized && optimized.bestModel ? optimized.bestModel.label : ""}</div>
        </div>
        <div className={styles.modelBot}>
          <div className={styles.mSubTitle}>{"Growth Over Profit"}</div>
          <div>{"I help prioritize growing your business"}</div>
        </div>
        <div className={styles.modelInfo} style={{ marginTop: "20px" }}>
          <div className={styles.infoType}>{"Revenue"}</div>
          <div className={styles.infoBar}>
            <div className={styles.filledBar} style={{ width: nRevenue + "%" }} />
          </div>
          <div className={styles.infoScore}>{nRevenue >= 80 ? "High" : nRevenue >= 45 ? "Medium" : "Low"}</div>
        </div>
        <div className={styles.modelInfo} style={{ marginTop: "20px" }}>
          <div className={styles.infoType}>{"Cost"}</div>
          <div className={styles.infoBar}>
            <div className={styles.filledBar} style={{ width: nCost + "%" }} />
          </div>
          <div className={styles.infoScore}>{nCost >= 80 ? "High" : nCost >= 45 ? "Medium" : "Low"}</div>
        </div>
        <div className={styles.modelInfo} style={{ marginTop: "20px" }}>
          <div className={styles.infoType}>{"Accuracy"}</div>
          <div className={styles.infoBar}>
            <div
              className={styles.filledBar}
              style={{
                width: optimized && optimized.bestModel ? optimized.bestModel.maxIteration.accuracy * 100 + "%" : "0%"
              }}
            />
          </div>
          <div className={styles.infoScore}>
            {optimized && optimized.bestModel && optimized.bestModel.maxIteration.accuracy * 100 >= 80
              ? "High"
              : optimized && optimized.bestModel && optimized.bestModel.maxIteration.accuracy * 100 >= 45
                ? "Medium"
                : "Low"}
          </div>
        </div>
      </div>
    );
  }

  renderDetails() {
    const { modelGroups } = this.props;

    if (modelGroups === undefined) {
      return <div />;
    }

    const topDrivers =
      modelGroups.topDrivers && modelGroups.topDrivers.length > 0 ? modelGroups.topDrivers[0] : undefined;

    const count = 5;

    const showValues = true;

    return (
      <div className={styles.mContentDetails}>
        <div className={styles.mSubTitle}>{"Key Drivers"}</div>
        {topDrivers &&
          topDrivers.columnDrivers &&
          topDrivers.columnDrivers
            .filter((m, i) => i < count)
            .map((m, i) => (
              <div className={styles.driverWrapper + " " + (showValues ? styles.hasValues : "")} key={i + m.field}>
                <div className={styles.driverTitle + " " + (showValues ? "" : styles.hideValues)}>{m.field}</div>
                {showValues ? (
                  <React.Fragment>
                    {m.maxName !== undefined ? (
                      <div className={styles.driverItem}>
                        <span className={styles.botDelta + " " + styles.increase}>
                          <FontAwesomeIcon style={{ marginRight: "10px" }} icon={faArrowAltCircleUp} />
                        </span>
                        <div>
                          <div>{this.parseValueName(m.maxName)}</div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {m.minName !== undefined ? (
                      <div className={styles.driverItem}>
                        <span className={styles.botDelta + " " + styles.decrease}>
                          <FontAwesomeIcon style={{ marginRight: "10px" }} icon={faArrowAltCircleDown} />
                        </span>
                        <div>
                          <div>{this.parseValueName(m.minName)}</div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </React.Fragment>
                ) : (
                  ""
                )}
              </div>
            ))}
      </div>
    );
  }

  renderEmpty() {
    return <div className={styles.modelContent}>{"EMPTY"}</div>;
  }

  renderPieChart(dataSource, isOptimized = true, isFullHeightModelBox = true) {
    if (!dataSource) {
      return null;
    }
    const { modelGroups, optimized, isNext, isOverallSegment, runId } = this.props;

    const drilldownValues = (modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues) || [];
    const units = optimized && optimized.unitLabelShort ? optimized.unitLabelShort : "";
    const segments = drilldownValues.filter((segment) => segment.label !== "Overall");

    const activeSlice =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.runId === runId)[0]
        : undefined;

    const pieData = segments
      ? segments.map((s) => ({
          name: s.value,
          runId: s.runId,
          value: Math.round(Math.abs(s[dataSource])),
          color: isOverallSegment
            ? s.color + (isOptimized ? "" : "50")
            : activeSlice && s.label === activeSlice.label
              ? s.color + (isOptimized ? "" : "50")
              : "#4b495b10"
        }))
      : [];

    const pieValuesSum =
      pieData && pieData.length > 0 && pieData.map((segment) => segment.value).reduce((a, b) => a + b);

    return pieData.length > 0 ? (
      isFullHeightModelBox ? (
        <PieChart showSegments pData={pieData} unit={units} hideLegend hideTooltip isNext />
      ) : (
        pieData.map((segment) => (
          <div
            style={{
              height: "100%",
              width: `${Math.round((segment.value / pieValuesSum) * 100)}%`,
              backgroundColor: segment.color
            }}
            key={`piedata_${segment.runId}`}
          ></div>
        ))
      )
    ) : null;
  }

  renderSegmentLegend() {
    const { modelGroups } = this.props;

    const drilldownValues = (modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues) || [];
    const segments = drilldownValues.filter((segment) => segment.label !== "Overall");
    return segments.length > 0 ? (
      <div className={styles.segmentsLegend}>
        {segments.map((segment, index) => (
          <div
            key={"legend" + segment.label}
            className={styles.legendItem}
            style={index > 0 ? { marginLeft: "8px" } : {}}
          >
            <div className={styles.legendBullet} style={{ backgroundColor: segment.color }}></div>
            <div>{segment.label}</div>
          </div>
        ))}
      </div>
    ) : null;
  }

  renderError() {
    const { errorMessages, isOverallSegment, modelGroups, runId } = this.props;

    return (
      <div className={styles.errorMessagesWrapper + " " + (this.state.hideErrors ? styles.isHide : "")}>
        <div className={styles.errorMessagesToggle}>
          <Icon type={"warning"} style={{ marginRight: "6px" }} />
          <a
            onClick={() => {
              this.setState({ hideErrors: !this.state.hideErrors });
            }}
          >
            {this.state.hideErrors ? "Show Errors" : "Hide Errors"}
          </a>
        </div>
        {!this.state.hideErrors && (
          <ModelError
            isNext
            errors={errorMessages}
            runId={runId}
            isOverallSegment={isOverallSegment}
            modelGroups={modelGroups}
          />
        )}
      </div>
    );
  }

  render() {
    const {
      nextId,
      runId,
      isSmall,
      isContinuous,
      isNextStrategy,
      hideFooter,
      optimized,
      deploy,
      title,
      background,
      isMini,
      updateCurrentStep,
      isScenarioDeployed,
      overallOnly,
      modelGroups,
      setup,
      overallSetup,
      setupLabels,
      costLabel,
      profitLabel,
      isNext,
      revenueLabel,
      strategy,
      isOverallSegment,
      modelCount,
      isDone,
      project,
      account,
      hasErrors
    } = this.props;
    const { mode, isDeployingProject } = this.state;

    let fontColor = "white";
    let activeColor = "#7E69D7";
    if (
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId && d.value !== "Overall").length > 0
    ) {
      activeColor = modelGroups.drilldownValues.filter((d) => d.runId === runId)[0].color;
      fontColor = "#4B495B";
    }

    let objective = profitLabel ? profitLabel : "Impact";

    if (overallSetup && overallSetup.primaryBusinessConstraintType) {
      const currentObjective = overallSetup.primaryBusinessConstraintType;
      switch (currentObjective) {
        case "profit":
          objective = profitLabel;
          break;
        case "revenue":
          objective = revenueLabel;
          break;
        case "cost":
          objective = costLabel;
          break;
      }
    }

    const numSegments = modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues.length;

    const determineBoxWidth = isNext
      ? { width: "100%" }
      : strategy && !isOverallSegment && numSegments > 1
        ? { width: "650px" }
        : {};

    const currentlyOverallSegment =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId && d.column == "Overall").length > 0
        ? true
        : false;

    const deployAIButton = () => {
      return (
        <Button
          type="primary"
          disabled={isScenarioDeployed}
          onClick={() => {
            this.setState({ isDeployingProject: true });
            return deploy().then(() => {
              this.setState({ isDeployingProject: false });
              return updateCurrentStep(UNIFIED_PROJECT_STEPS.INTEGRATE.id);
            });
          }}
          style={{ marginBottom: "20px" }}
        >
          {isDeployingProject ? (
            <LoadingIndicator
              style={{
                width: "20px",
                height: "18px",
                transform: "scale(0.30)",
                margin: "-5px 5px 5px -5px"
              }}
            />
          ) : isScenarioDeployed ? (
            "AI Deployed"
          ) : (
            "Deploy AI"
          )}
        </Button>
      );
    };

    const runCost =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues
        .filter((d) => {
          if (currentlyOverallSegment) {
            return d.value !== "Overall" || project?.segments?.length === 1;
          } else {
            return d.runId === runId;
          }
        })
        ?.reduce((acc, d) => {
          return acc + (d?.runCost ?? 0);
        }, 0);

    return (
      <div
        className={styles.modelBox + " " + styles.mHeaderRadius + " " + (isMini ? styles.miniBox : "")}
        style={determineBoxWidth}
      >
        <div
          className={isMini ? styles.miniHeader : isSmall ? styles.sHeader : styles.mHeader}
          style={background ? { background: background } : { backgroundColor: activeColor }}
        >
          <div className={styles.headerTitleWrapper} style={isNext ? { height: "31px" } : {}}>
            {isNext ? (
              <div>
                <div className={styles.headerTitle} style={{ marginBottom: "0px", color: fontColor }}>
                  {"Expected Results"}
                </div>
                {(nextId !== "new" || optimized !== undefined) && (
                  <div style={{ color: fontColor }}>
                    <span>{modelCount + " Models Completed"}</span>
                    {!isNaN(runCost) && account?.type !== "AZURE" && (
                      <span className={styles.runCost} style={{ borderColor: fontColor }}>
                        {"Total Spent: $" + runCost.toFixed(2)}
                      </span>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <OverlayTrigger
                placement={"bottom"}
                trigger={isNext ? ["hover"] : []}
                overlay={<Popover id={"popover-positioned-bottom"}>{`${modelCount} Models Completed`}</Popover>}
              >
                <div className={styles.headerTitle} style={{ marginBottom: "0px", color: fontColor }}>
                  {isNext
                    ? "Expected Results"
                    : title
                      ? title
                      : objective
                        ? `AI Optimized for ${objective}`
                        : `Optimal AI for ROI`}
                </div>
              </OverlayTrigger>
            )}
            {isNext && !isDone && optimized !== undefined ? (
              <div className={styles.headerTitleLoading}>
                <LoadingIndicator
                  style={{
                    width: "25px",
                    height: "25px",
                    transform: "scale(0.40)",
                    margin: "-10px 5px 5px -8px"
                  }}
                  color={fontColor}
                />
              </div>
            ) : (
              <React.Fragment />
            )}
          </div>
          {
            /*optimized ? (
            <div className={styles.headerTabs}>
              <ButtonGroup>
                <Button
                  active={mode === "OVERVIEW"}
                  onClick={() => this.setState({ mode: "OVERVIEW" })}
                >
                  {"Overview"}
                </Button>
                <Button
                  active={mode === "MODEL"}
                  onClick={() => this.setState({ mode: "MODEL" })}
                >
                  {"Model"}
                </Button>
                <Button
                  active={mode === "DETAILS"}
                  onClick={() => this.setState({ mode: "DETAILS" })}
                >
                  {"Details"}
                </Button>
              </ButtonGroup>
            </div>
          ) : (*/
            <div />
            //)
          }
        </div>
        {isNext && (
          <div className={styles.nextFunnelTitle}>
            <strong style={{ marginBottom: "5px" }}>Strategy</strong>
            <BusinessConstraints id={this.props.id} setupLabels={this.props.setupLabels} overviewOnly={true} />
          </div>
        )}
        {hasErrors && this.renderError()}
        {hasErrors && !this.state.hideErrors ? (
          <div />
        ) : optimized === undefined ? (
          this.renderOverview()
        ) : mode === "MODEL" ? (
          this.renderModel()
        ) : mode === "DETAILS" ? (
          this.renderDetails()
        ) : (
          this.renderOverview()
        )}
        {optimized && !(hasErrors && !this.state.hideErrors) ? (
          hideFooter || isMini ? (
            <div />
          ) : !isNext &&
            (((isSmall || isContinuous) && isNextStrategy !== true) ||
              (optimized && optimized.bestModel && strategy)) ? (
            <div className={isSmall ? styles.mFooterSmall : styles.mFooter}>
              <div className={styles.mSubTitle} style={{ fontWeight: "bold", margin: "0px 10px 5px 10px" }}>
                {`Get started now and recalibrate at any time`}
              </div>
              <div className={styles.mSubTitle} style={{ fontWeight: "normal", margin: "0px 20px 10px 20px" }}>
                {
                  "Your future data might differ from the training data and users may not follow recommendations so your actual results will differ from the estimate above. Just get started. You will be able to observe and recalibrate your AI with a single click at any time."
                }
              </div>
              {deployAIButton()}
            </div>
          ) : (
            <div className={styles.mFooter}>
              {optimized && optimized.bestModel ? null /*<React.Fragment>
                  <div className={styles.sSubTitle} style={{marginTop:"5px",marginBottom:"10px"}}>
                    {
                      "You can proceed to setting business strategy, but Aible recommends"+
                      " reviewing the business drivers for all subgroups to optimze profit and calculate a $ ROI"
                    }
                  </div>
                </React.Fragment>*/ : optimized && !isNext ? (
                <React.Fragment>
                  <div className={styles.sSubTitle}>
                    {"You can deploy now but we recommend waiting for the training to " +
                      "complete and adding your business context to improve the impact"}
                  </div>
                  <LoadingIndicator
                    style={{
                      width: "48px",
                      height: "48px",
                      transform: "scale(0.75)",
                      margin: "0px 5px 15px -5px"
                    }}
                  />
                </React.Fragment>
              ) : null}
              {isNext ? (
                this.renderSegmentLegend()
              ) : strategy ? (
                deployAIButton()
              ) : (
                <Button
                  type={"primary"}
                  onClick={() => updateCurrentStep(UNIFIED_PROJECT_STEPS.BUSINESS_STRATEGY.id)}
                  style={{ marginBottom: "20px" }}
                >
                  {"Set Business Strategy"}
                </Button>
              )}
            </div>
          )
        ) : (
          <div />
        )}
      </div>
    );
  }
}
